import React from "react";
import { withStyles } from "@material-ui/styles";
import { withRouter } from "react-router-dom";
import { I18n } from "@aws-amplify/core";

import Grid from "@material-ui/core/Grid";
import Tabs from "@material-ui/core/Tabs";

import CustomTab from "../Common/CustomTab";

// import { vmirequests, vmiorders } from "../../constants/common";

import colors from "../../assets/style/colors";

const styles = {
  container: {
    height: "50px",
    width: "100%",
    backgroundColor: colors.white,
    borderBottom: "1px solid rgba(0,0,0,0.23)",

    '@media(max-width: 470px)' : {
      display: "none",
    }
  },
  tabs: {
    height: "50px",
    float: "left",
    minHeight: "50px",
  },
};

const VMITopBar = (props) => {
  const { classes, section } = props;

  const [tab, setTab] = React.useState(section)

  React.useEffect(() => {

    setTab(props.section)
    
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.section]);

  return (
    <Grid container className={classes.container}>
      <Tabs
        value={tab}
        onChange={(e, value) => {props.handleChangeView(value); setTab(value)}}
        indicatorColor="primary"
        centered
        className={classes.tabs}
      >
        <CustomTab
          height="50px"
          label={I18n.get("vmi_requests")}
          value={"requests"}
        />
        <CustomTab
          height="50px"
          label={I18n.get("vmi_orders")}
          value={"orders"}
        />
      </Tabs>
    </Grid>
  );
};

export default withStyles(styles)(withRouter(VMITopBar));
